import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
     Button,
    useMediaQuery
} from "@mui/material";
import {Headset, MessagesSquare} from "lucide-react";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {theme} from "../../../config/design/theme";
import TicketScreen from "./TicketScreen";
import axios from "axios";
import {defaultVariables} from "../../../config";
import {LoadingButton} from "@mui/lab";
import {useSnackbar} from "notistack";

const TicketButton = ({list_id,className,color = "primary" , variant = 'contained',icon,title,reload,is_closed}) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [list, setList] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const token = localStorage.getItem("ACT");
    const { enqueueSnackbar } = useSnackbar();

    const openDialog = async () => {
        setSubmitLoading(true);
        try {
            const response = await axios.get(`${defaultVariables.url}/tickets/get-list${!!list_id ? "/"+list_id : ""}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            await setList(response.data);
            await setOpen((prev) => !prev);
        }catch (e) {
            console.log(e)
            enqueueSnackbar(t('cantMakeMoreTicket'), { variant: 'error' });

        }
        await setSubmitLoading(false);

    }
    const closeDialog = async () => {
        await setOpen((prev) => !prev);
        if(!!reload){
            reload();
        }

    }

    return (
        <>
            <LoadingButton
                color={color}
                variant={variant}
                onClick={openDialog}
                className={className}
                startIcon={!!icon ? icon : <Headset/>}
                loading={submitLoading}
            >
                {!!title ? title : t('sendTicketToSupport')}
            </LoadingButton>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={closeDialog}
                open={open}
                fullScreen={!!isMobile}
            >
                <DialogTitle className="dialog-title">
                    {!!title ? title : t('sendTicketToSupport')}
                    <IconButton
                        onClick={() => closeDialog()}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <TicketScreen list={list} is_closed={is_closed}/>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default TicketButton;
